/* eslint-disable quotes */
/* eslint-disable camelcase */
/* eslint-disable import/no-mutable-exports */

export let API_BASE_URL = '';
export let CM_BASE_URL = '';
export let SALESGEAR_URL = '';
export let SALESGEAR_WEBSITE = '';

export let PORT = '';
export let NEW_ADMIN_BASE_URL = '';
export let NEW_ADMIN_PORT = '';
export let LB_WEB_BASE_URL = '';
export let LB_WEB_BASE_PORT = '';

export let MX_PANEL_KEY = 'f8e57d35bafd760bcec71d6133605a11';
export let STRIPE_KEY = 'pk_test_dzqlmaesARo2zviSbEyyOYfu';
export let GTM_KEY = 'GTM-PMT793B';
export let HUBSPOT_PORTAL_ID = '5640795';
export let HUBSPOT_FORM_ID = 'ae8e9020-59e1-4ae5-bfa2-c6c0eee4723c';
export let SELF_TRIAL_HUBSPOT_FORM_ID = '27d1e618-eb58-4224-a6c3-6df31356bf8a';
export let SELF_TRIAL_UPGRADE_HUBSPOT_FORM_ID =
  '27164b89-0d18-4833-aac8-7e724aa84850';
export const DRIFT_KEY = '34cee668imvp';
export const S3_BASE_PATH = 'https://s3-us-west-1.amazonaws.com/';
export let S3_BUCKET_PATH = 'leads.adaptqe.com';
export let MINIMUM_LIMIT_OF_BACKGROUND_PURCHASE_PROCESS = 250;
export let TOTANGO_SERVICE_ID = 'SP-41047-01';
export let TAM_RESULT_COUNT_MINIMUM = 25;
export let PROSPECTOR_USER_TRIAL_FORM = '353fff5c-fd3c-43e2-aaea-653fa85970c3';
export let REQUEST_QUOTE_FORM = '8f6062aa-c0bc-4d5d-a293-e585c4fba011';

export let DASHBOARD_ALLOWED_SUBSCRIPTION_IDS = ['6112270cb10e600e2f9398ef'];

if (process.env.BUILD_ENV === 'staging') {
  API_BASE_URL = 'https://www.adaptqe.com';
  CM_BASE_URL = 'https://app.adaptqe.com';
  PORT = '';
  NEW_ADMIN_BASE_URL = 'https://retina.adaptqe.com';
  LB_WEB_BASE_URL = 'https://leads.adaptqe.com';
  SALESGEAR_URL = 'https://app.salesgearqe.com';
  SALESGEAR_WEBSITE = 'https://salesgearqe.com';
  HUBSPOT_PORTAL_ID = '7022180';
} else if (process.env.BUILD_ENV === 'local') {
  API_BASE_URL = 'http://localhost';
  CM_BASE_URL = 'http://localhost:9000';
  SALESGEAR_URL = 'http://localhost:3000';
  PORT = ':8080';
  NEW_ADMIN_BASE_URL = 'http://localhost';
  NEW_ADMIN_PORT = ':4000';
  LB_WEB_BASE_URL = 'http://localhost';
  LB_WEB_BASE_PORT = ':3000';
  SALESGEAR_WEBSITE = 'https://salesgearqe.com';
  // MX_PANEL_KEY = '2220c589024120d61822c6977c8ccda4';
  HUBSPOT_PORTAL_ID = '7022180';
} else if (process.env.BUILD_ENV === 'localqe') {
  API_BASE_URL = 'http://192.168.0.160';
  CM_BASE_URL = 'https://app.adaptqe.com';
  SALESGEAR_URL = 'https://app.salesgearqe.com';
  PORT = ':8080';
  SALESGEAR_WEBSITE = 'https://salesgearqe.com';
} else {
  // Production
  API_BASE_URL = 'https://www.adapt.io';
  CM_BASE_URL = 'https://app.adapt.io';
  NEW_ADMIN_BASE_URL = 'https://retina.adapt.io';
  LB_WEB_BASE_URL = 'https://leads.adapt.io';
  SALESGEAR_URL = 'https://app.salesgear.io';
  SALESGEAR_WEBSITE = 'https://salesgear.io';
  PORT = '';

  MX_PANEL_KEY = 'dbc42f15543c1eef23f00b8931511463';
  STRIPE_KEY = 'pk_live_xzqlAalsdvQbcLLx1Ia2mv3K';
  GTM_KEY = 'GTM-WJDZDLZ';
  HUBSPOT_PORTAL_ID = '5640795';
  HUBSPOT_FORM_ID = '3f8ed314-d618-46aa-9950-9eb766c35a6b';
  SELF_TRIAL_HUBSPOT_FORM_ID = '71eeee83-f186-4411-83d4-7fd161ab5b40';
  SELF_TRIAL_UPGRADE_HUBSPOT_FORM_ID = '9cc6d82c-81c4-49a9-a09d-84c1418e984b';
  S3_BUCKET_PATH = 'leads.adapt.io';
  MINIMUM_LIMIT_OF_BACKGROUND_PURCHASE_PROCESS = 25000;
  TOTANGO_SERVICE_ID = 'SP-28949-01';
  TAM_RESULT_COUNT_MINIMUM = 1000;
  DASHBOARD_ALLOWED_SUBSCRIPTION_IDS = [
    '5f9c3430a78420273a40ca17',
    '6225ab92e9ec7453dd092fb5',
  ];
  PROSPECTOR_USER_TRIAL_FORM = '71eeee83-f186-4411-83d4-7fd161ab5b40';
  REQUEST_QUOTE_FORM = '8f6062aa-c0bc-4d5d-a293-e585c4fba011';
}

export const BASE_LOGIN_URL = '/login.htm?slc=web&login=true';

export const WEB_URL = API_BASE_URL + PORT;

export const LB_WEB_URL = LB_WEB_BASE_URL + LB_WEB_BASE_PORT;

export const NEW_ADMIN_URL = NEW_ADMIN_BASE_URL + NEW_ADMIN_PORT;
export const EXTERNAL_S3_SCRIPTS = {
  INSPECTLET_SESSION_RECORDING:
    '/custom-scripts/inspectlet-session-recording.js',
};

export const THIRD_PARTY_SCRIPTS = {
  REGISTRATION_TRACKING: {
    ID: 'capteraTrackingId',
    SCRIPT_URL:
      'https://ct.capterra.com/capterra_tracker.gif?vid=2124559&vkey=60d19165f0c299107f5ef95278a0e57a',
  },
};

export const trialOnboarding = {
  status: {
    COMPLETE: 'COMPLETE',
    INCOMPLETE: 'INCOMPLETE',
    SKIPPED: 'SKIPPED',
  },
  type: {
    LEAD_BUILDER: 'LB',
    PROSPECTOR: 'PROSPECTOR',
  },
  searchJson: {
    companyName: ['Amazon.com'],
    // dept: ['Human Resources'],
    dontDisplayDeadContacts: true,
    dontDisplayOwnedContacts: true,
    dontDisplayTeamContacts: true,
    ecsPercentage: '*',
    locationPreferences: '*',
    exactTitleMatch: false,
    limit: 50,
  },
  links: {
    prospectorPlugin:
      'https://chrome.google.com/webstore/detail/linkedin-email-finder-ada/abpjeombpodcafecdidejijglognakhe',
    prospectorInstallBlog:
      'https://www.adapt.io/blog/how-to-install-adapt-prospector-chrome-extension/',
  },
};

export const CRM_EXPORT_LIMIT = 5000;
export const EXPORT_SOURCE = {
  ADVANCED_SEARCH: 'advancedSearch',
  MY_LEADS: 'myLeads',
};

export const EXPORT_PAGE_SOURCE = {
  ADVANCED_SEARCH: 'ADVANCED_SEARCH',
  MY_LEADS: 'MY_LEADS',
};

export const USER_SOURCE = {
  ADAPT_PROSPECTOR: 'plugin-li',
  ADAPT_WEB: 'web',
};

export const CRM_EXPORT_AS_TYPE = {
  LEAD: 'LEAD',
  CONTACT: 'CONTACT',
};

export const PAGE_PATH_MAP = {
  INTEGRATIONS: '/integrations',
  MANAGE_TEAM: '/manage-team',
  CONTACT_SEARCH: '/advanced-search/contact#search',
  BILLING: '/profile/billing',
  BUY_MORE_CREDITS: '/profile/buy-more-credits',
  PASSWORD_SETUP: '/password-setup',
  ONBOARDING: '/onboarding',
  CONTACT_SEARCH_SAVED_SEARCHES: '/advanced-search/contact/saved-searches',
  PRICING: '/pricing',
};

export const CONTACT_COUNT_IN_MILLIONS = '200M+';

export const MX_PANEL_PAGETYPE = {
  DASHBOARD: 'Dashboard',
  ADVANCED_SEARCH: 'AS',
  MY_LEADS: 'My Leads',
  SEEKER: 'Seeker',
  EDIT_PROFILE: 'Edit Profile',
  EXCHANGE_CONTACTS: 'Exchange Contacts',
  MANAGE_TEAM: 'Manage Team',
  SUPPRESSION_LIST: 'Suppression List',
  SALESFORCE_MAPPING: 'Salesforce Mapping',
  PRICING_CALCULATOR: 'Pricing Calculator',
  PRICING: 'Pricing',
  CONCIERGE: 'Concierge',
  INSIDE_STORY: 'Inside Story',
  INSIDE_STORY_ENKI: 'Inside Story Enki',
  ACTIVATE_ACCOUNT: 'Activate Account',
  PASSWORD_SETUP: 'Password Setup',
};

export const MX_COMMON_EVENTS = {
  ABS_PERFORMED: 'ABS performed',
  LB_SALESGEAR_BTN_CLICK: 'LB - Salesgear Btn Click',
  LB_SALESGEAR_ICON_CLICK: 'LB - Salesgear Icon Click',
  LB_UPGRADE_CLICK: 'LB - Upgrade Clicked',
};

export const MX_DASHBOARD_EVENTS = {
  ADV_SEARCH_CLICKED: 'Advanced Search click',
};

export const MX_LB_EXPORT_EVENTS = {
  LB_CLICK_EXPORT: 'LB - Click - Export',
  LB_CLICK_DOWNLOAD_CSV: 'LB - Click - Download as CSV',
  LB_CLICK_EXPORT_UPGRADE: 'LB - Click - Export Upgrade',
  LB_CLICK_SELECT_EXPORT_TYPE: 'LB - Click - Select Export Type',
  LB_VIEW_EXPORT_SUCCESS: 'LB - View - Export Sucess',
  LB_VIEW_EXPORT_FAILED: 'LB - View - Export Failed',
  LB_VIEW_EXPORT_LIMIT_EXCEED: 'LB - View - Export Limit Exceed',
  LB_SF_EXPORT_ASSIGN_OWNERS: 'LB - SF - Assign Owners',
  LB_HS_EXPORT_ASSIGN_OWNERS: 'LB - HS - Assign Owners',
};

export const MX_ML_EVENTS = {
  ML_VIEWED: 'My Leads Viewed',
  ML_EXPORT_CLICK: 'ML-Export Click',
  ML_EXPORT_TYPE_CLICK: 'ML-Export Type Click',
  ML_EXPORT_SUCCESS: 'ML-Export Success',
  ML_EXPORT_FAILED: 'ML-Export Failed',
  ML_EXPORT_LIMIT_EXCEED: 'ML-Export limit Exceed',
  ML_EXPORT_UPGRADE_CLICK: 'ML-Export Upgrade Click',
  ML_LIST_CREATED: 'ML - List Created',
  ML_LIST_DELETED: 'ML - List Deleted',
  ML_LIST_RENAMED: 'ML - List Renamed',
  ML_COPY_CLICKED: 'ML - Copy clicked',
  ASSIGN_OWNERS: {
    SALESFORCE: 'ML - SF - Assign Owners',
    HUBSPOT: 'ML - HS - Assign Owners',
  },
  ML_MS_DYNAMICS_EXPORT_ASSIGN_OWNERS: 'ML - MS DYNAMICS - Assign Owners',

  ML_UPGRADE_NOW_FREE_USER: 'ML - Click - Upgrade Now Popup',
  ML_RESULT_HOVER_COMPANY_NAME: 'ML - Result - Hover - Company Name',
  ML_WEB_PAYWALL_VIEWED: 'ML - Web Paywall tooltip viewed',
  ML_CONTACT_NAME_CLICK: 'ML - Job Update Contact Name click',
  ML_LIST_PAGE_VIEWED: 'ML - List Page Viewed',
  ML_LIST_PAGE_PAGINATION_CLICK: 'ML - List Page Pagination Click',
  ML_VIEWS_EXPIRED: 'ML - Result Views Expired Popup',
  ML_PAYWALL_PRICING_POPUP: 'ML - Pricing Popup Viewed - New',
  ML_JOB_CHANGE_PURCHASED: 'ML - Job Changes Purchased',
};

export const MX_AS_EVENTS = {
  AS_FILTER_SHOW_LESS_CLICKED: 'AS Results - Show Less Clicked',
  AS_FILTER_SHOW_MORE_CLICKED: 'AS Results - Show More Clicked',
  AS_TAG_REMOVED: 'AS Results - Tag removed',
  AS_COPY_CLICKED: 'AS Results Copy clicked',
  AS_DOWNLOAD_CLICK: 'AS-Download Click',
  AS_CONTACT_NAME_CLICK: 'AS-Contact Name click',
  AS_PHONE_SCORE_LOCK_CLICK: 'AS-Phone Score Lock click',
  AS_VIEW_CONTACT_CONSUMED: 'Advance Search Contact Consumed',
  AS_VIEW_ALL_FILTERS_CLICKED: 'View All Filters clicked',

  AS_TITLE_SEARCH_PERFORMED: 'AS-Title Search Performed',
  AS_CITY_SEARCH_PERFORMED: 'AS-City Search Performed',
  AS_COUNTRY_SEARCH_PERFORMED: 'AS-Country Search Performed',
  AS_EMPLOYEE_COUNT_SEARCH_PERFORMED: 'AS-Employee Count Performed',
  AS_INDUSTRY_KEYWORD_SEARCH_PERFORMED: 'AS-Industry Keyword Search Performed',
  AS_LEVEL_SEARCH_PERFORMED: 'AS-Level Search Performed',
  AS_ZIP_SEARCH_PERFORMED: 'AS-Zip Search Performed',
  AS_STATE_SEARCH_PERFORMED: 'AS-State Search Performed',
  AS_LIST_SEARCH_PERFORMED: 'AS-List Search Performed',
  AS_REVENUE_SEARCH_PERFORMED: 'AS-Revenue Count Performed',
  AS_REGIONS_SEARCH_PERFORMED: 'AS-Regions Search Performed',
  AS_DEPARTMENT_SEARCH_PERFORMED: 'AS-Deparment Search Performed',
  AS_COMPANY_SEARCH_PERFORMED: 'AS-Company Search Performed',
  AS_EXCLUDE_COUNTRY_SEARCH_PERFORMED: 'AS-Exclude Country Search Performed',
  AS_LEAD_NAME_SEARCH_PERFORMED: 'AS-Lead Name Search Performed',
  AS_COMPANY_KEYWORD_SEARCH_PERFORMED: 'AS-Company Keyword Search Performed',
  LB_AS_LOCATION_SEARCH_PERFORMED: 'LB - AS - Location Search Performed',
  LB_AS_INDUSTRY_SEARCH_PERFORMED: 'LB - AS - Industry Search Performed',
  LB_AS_TECHNOLOGY_SEARCH_PERFORMED: 'LB - AS - Technology Search Performed',
  LB_AS_INCLUDE_COMPANY_SEARCH_PERFORMED:
    'LB - AS - Include Company Search Performed',
  LB_AS_EXCLUDE_COMPANY_SEARCH_PERFORMED:
    'LB - AS - Exclude Company Search Performed',
  LB_AS_TECHNOLOGY_SEARCH_SCHEDULE_DEMO:
    'LB - AS - Technology Search - Click - Schedule demo',
  LB_AS_TECHNOLOGY_FILTER_POPUP_VIEW: 'LB - AS - Technographics - Popup - View',
  LB_AS_TECHNOLOGY_FILTER_POPUP_CLICK_NOT_INTERESTED:
    'LB - AS - Technographics - Popup - Click - Not interested',
  LB_AS_PAGINATION_UPGRADE_NOW: 'LB - AS - Pagination - Click - Upgrade Now',
  LB_AS_PAGINATION_CLICK: 'LB - AS - Click Pagination',

  AS__SEARCH_PERFORMED: 'AS-Industry Keyword Filtered', //
  AS_INDUSTRY_SEARCH_PERFORMED: 'AS-Industry Keyword Search Viewed', //
  AS_HELP_CLICKED: 'AS-Help Link Clicked', //

  AS_INSUFFICIENT_POPUP: 'AS-Insufficient Popup', //
  AS_LIMIT_EXCEED_POPUP: 'AS-Lead Selection Limit Exceed',

  AS_LEAD_ADDED: 'AS-Lead Added',
  AS_LEAD_DOWNLOADED: 'AS-Lead Download',
  AS_LEAD_PURCHASE_FAIL_LIMIT: 'AS-Lead Purchase Failure Limit', //
  AS_LIST_CLICKED: 'AS-List Clicked', //
  AS_LIST_CREATED: 'AS-List Created',
  AS_LIST_SELECTED: 'AS-List Selected', //
  AS_DOWNLOAD_EXPIRED: 'AS-Result Downlaod Expired Popup',
  AS_VIEWS_EXPIRED: 'AS-Result Views Expired Popup',
  AS_CUSTOM_TOP_CONTACTS_SELECTED: 'Custom Top Contacts Selected', //
  AS_LEAD_BUILDER_VIEWD: 'Lead Builder viewed',
  AS_SAVE_SEARCH_CLICKED: 'Save this Search Clicked',
  AS_SAVE_SEARCH_CREATED: 'Saved Search Created',
  AS_SAVE_SEARCH_DELETED: 'Saved Search Deleted',
  AS_SAVE_SEARCH_RENAMED: 'Saved Search Renamed',
  AS_OPEN_SAVED_SEARCH: 'Opened Saved Search',

  AS_PAYWALL_UPGRADE_POPUP: 'Upgrade Popup - Paid Users',
  AS_PAYWALL_PRICING_POPUP: 'Pricing Popup Viewed - New',

  AS_WEB_PAYWALL_VIEWED: 'Web Paywall tooltip viewed',
  AS_WEB_PAYWALL_CLICKED: 'Web Paywall tooltip clicked',
  LB_RESULT_HOVER_COMPANY_NAME: 'LB - Result - Hover - Company Name',
  AS_LIMIT_CONTACT_PER_COMPANY: {
    PURCHASE_VIEWS_EXCEEDED:
      'AS - Limit contact per company purchase - views exceeded',
    PURCHASE_UNONKOWN_ERROR:
      'AS - Limit contact per company purchase - unknown error',
    PURCHASE_SUCCESS: 'AS - Limit contact per company purchase - succes',
  },
  AS_LB_COMPANY_PAGE: {
    VIEW_CONTACTS_CLICK: 'LB - Company Page - Click - View Contacts',
    COPY_PHONE_CLICK: 'LB - Company Page - Click - Copy Phone Number',
  },
  AS_LB_CONTACT_PURCHASED: 'LB - Contact Purchased',
  AS_LB_SEARCH_PERFORMED: 'LB - Search Performed',
};

export const MX_SAVED_SEARCH_EVENTS = {
  CREATE_SAVED_SEARCH: 'LB - Contact Saved Search Create',
  EDIT_SAVED_SEARCH: 'LB - Contact Saved Search Edit',
  REPLACE_SAVED_SEARCH: 'LB - Contact Saved Search Replace',
  DELETE_SAVED_SEARCH: 'LB - Contact Saved Search Delete',
  SHARE_SAVED_SEARCH: 'LB - Contact Saved Search Shared',
  UNSHARE_SAVED_SEARCH: 'LB - Contact Saved Search UnShared',
  CLICK_SHOW_ALL_SEARCHES: 'LB - Contact Saved Search Show All Clicked',
  CLICK_LOAD_SAVED_SEARCH_AS_PAGE:
    'LB - AS - Contact Saved Search Single Item Clicked',
  AS_SAVED_SEARCHES_CLICKED: 'LB - Contact Saved Search Link Clicked',
  SAVED_SEARCH_PAGE_LOAD: 'LB - Contact Saved Search Page Viewed',
  OPEN_SEARCH_CLICKED: 'LB - Contact Saved Search Open Search Clicked',
  NEW_CONTACTS_BUTTON_CLICKED: 'LB - Contact Saved Search New Contacts Clicked',
  NEW_CONTACTS_TAB_CLICK:
    'LB - Contact Saved Search - New Contacts Tab Clicked',
  ALL_CONTACTS_TAB_CLICK:
    'LB - Contact Saved Search - All Contacts Tab Clicked',
  SAVED_SEARCH_POPUP_SHOWN: 'LB - Saved Search Popup Shown',
  EMAIL_NOTIFICATION_TOGGLED: 'LB - Saved Search Email toggled',
  UPGRADE_CLICKED: 'LB - Saved Search Upgrade Clicked',
  EMPTY_RESULTS_SAVE_SEARCH_CLICK: 'LB - Empty Results Save Search Clicked',
};

export const TOTANGO = {
  EVENTS: {
    SEARCH: 'Search',
    PURCHASE: 'Purchase',
    EXPORT: 'Export',
    CSV_DOWNLOAD: 'CSV',
  },
  MODULES: {
    LB: 'LB',
    MY_LEADS: 'My Leads',
    DASHBOARD: 'Dashboard',
  },
};

export const MX_SUPPRESSION_LIST_EVENTS = {
  LB_SL_ADD_LIST: 'LB - SL - CTA - Add List',
  LB_SL_ADD_LIST_VERIFY: 'LB - SL - Add List - Verifying',
  LB_SL_SAVE_LIST: 'LB - SL - CTA - Save',
  LB_SL_TOGGLE: 'LB - SL - Toggle - Exclude',
  LB_SL_DELETE: 'LB - SL - CTA - Delete',
  LB_SL_DOWNLOAD: 'LB - SL - CTA - Download',
  LB_SL_LIST_CREATED_SUCCESS: 'LB - SL - List Created Successfully',
  LB_SL_UPLOAD_FAILED: 'LB - SL - Upload failed',
};

export const MX_SF_MAPPING_EVENTS = {
  SF_CUSTOM_FIELD_CREATED: 'SF - Custom field created',
};

export const MX_SEEKER_EVENTS = {
  SEEKER_TASK_CREATED: 'LB - SEEKER - Task Created',
};

export const CONCIERGE_UPLOAD_CSV_FILE_LIMIT = 500;
export const MX_CONCIERGE_EVENTS = {
  CONCIERGE_TASK_CREATED: 'LB - CONCIERGE - Task Created',
};

export const MX_EVENTS_AE = {
  bannerShown: 'AE - LB Banner Shown',
  bannerClicked: 'AE - LB Banner Clicked',
  introExportBtn: 'AE - LB Introduce Salesgear Button Clicked',
  exportContact: 'AE - LB Icon Clicked',
  addContactClicked: 'AE - LB Export Contact Clicked',
  addSequenceClicked: 'AE - LB Add to Sequence Clicked',
  createSeqShown: 'AE - LB Create Sequence Shown',
  createSeqClicked: 'AE - LB Create Sequence Clicked',
  addEmailAccountShown: 'AE - LB Add Email Account Shown',
  addEmailAccountClicked: 'AE - LB Add Email Account Clicked',
  addedToSequence: 'AE - LB Added to Sequence',
  aePhBannerClick: 'AE - Product Hunt Banner Clicked',
  aeSequenceStarted: 'AE - Sequence started',
};

export const CRM_EXPORT_TYPE = {
  MARKETO: 'Marketo',
  MICROSOFT_DYNAMICS: 'Microsoft Dynamics',
  SALESFORCE: 'Salesforce',
  ZOHO: 'Zoho',
  HUBSPOT: 'Hubspot',
  PIPEDRIVE: 'Pipedrive',
  OUTREACH: 'Outreach',
};

export const COMPANY_EXPORT_TYPE = {
  CSV: 'CSV',
  CRM: 'CRM',
};

export const EXTERNAL_LINKS = {
  DOCS_LINK: {
    MARKETO_INTEGRATION:
      'https://adaptio.freshdesk.com/support/solutions/articles/36000227543-adapt-marketo-integration',
    MICROSOFT_DYNAMICS_INTEGRATION:
      'https://adaptio.freshdesk.com/support/solutions/articles/36000229923-adapt-microsoft-dynamics-integration',
  },
  LEON_CALENDAR_LINK: 'https://meetings.hubspot.com/leon75',
  AMMAR_CALENDAR_LINK:
    'https://calendly.com/ammar-adapt/30-minute-meeting-clone',
  HUBSPOT_DEFAULT_CALENDAR_LINK: 'https://meetings.hubspot.com/aravind6',
  PROSPECTOR: {
    CHROME_STORE_LINK:
      'https://chrome.google.com/webstore/detail/linkedin-email-finder-ada/abpjeombpodcafecdidejijglognakhe',
    MANUAL_INSTALL_LINK:
      'https://www.adapt.io/blog/how-to-install-adapt-prospector-chrome-extension/',
    CHROME_STORE_FIND_WEBSITE_LINK:
      'https://chrome.google.com/webstore/detail/adapt-find-emails-on-webs/lbhigcppinlecjbkgkaapkfekijdndaj',
  },
  G2_REVIEW: 'https://www.g2.com/products/adapt-adapt/reviews',
};

export const TOAST_MSG_TYPES = {
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  INFO: 'INFO',
  SUCCESS_NEW: 'SUCCESS-NEW',
};

export const NOTIFICATION_BAR_TYPE = {
  ACTIVATION: 'ACTIVATION',
  PAYMENT_PENDING_REVIEW: 'PAYMENT_PENDING_REVIEW',
  NEW_FEATURE: {
    SUPPRESSION_LIST: 'SUPPRESSION_LIST',
  },
  TRIAL_DAYS_LEFT_NOTIFICATION: 'TRIAL_DAYS_LEFT_NOTIFICATION',
};

export const PAYMENT_MSG_STATUS = {
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
};

export const MX_TRIAL_ONBOARDING = {
  VIEW_LB_TRIAL_WELCOME: 'LB - Trial - View - welcome msg',
  CLICK_LB_TRIAL_WELCOME_START: 'LB - Trial - Click - welcome - start',
  CLICK_LB_TRIAL_SEARCH_NOW: 'LB - Trial - Click - Search now',
  CLICK_LB_TRIAL_VIEW_CONTACT: 'LB - Trial - Click - View contact',
  CLICK_LB_TRIAL_ADD_TO_LIST: 'LB - Trial - Click - Add to list',
  CLICK_LB_TRIAL_MY_LEADS: 'LB - Trial - Click - Access My Leads',
  CLICK_LB_TRIAL_CRM_SEE_HOW: 'LB - Trial - Click - See How ',
  CLICK_LB_TRIAL_UPGRADE_NOW: 'LB - Trial - Click - Upgrade now',
  CLICK_LB_TRIAL_UPGRADE_NOW_CONFIRM:
    'LB - Trial - Click - Upgrade now confirm',
  CLICK_LB_TRIAL_UPGRADE_NOW_FORM_FILL: 'LB - Trial - Click - Form 2 Upgrade',
  CLICK_LB_TRIAL_SCHEDULE_CALL: 'LB - Trial - Click - Schedule call',

  VIEW_LB_TRIAL_GETTING_STARTED: 'LB - Trial - View - Getting Started (GS)',
  CLICK_LB_TRIAL_GS_ADD_TEAM: 'LB - Trial - Click - GS- Add Team member',
  CLICK_LB_TRIAL_GS_CRM_EXPORT: 'LB - Trial - Click - GS- Export to CRM',
  VIEW_LB_TRIAL_CREDIT_EXHAUSTED:
    'LB - Trial - View - Popup - Credit Exhausted',
  VIEW_LB_TRIAL_TRIAL_EXPIRED: 'LB - Trial - View - Popup - Trial Expired',
  VIEW_LB_TRIAL_EXPORT_TO_CRM: 'LB - Trial - View - Popup - Export to CRM',
  CLICK_LB_TRIAL_EXPORT_CRM_LINK:
    'LB - Trial - Click - Popup - Export CRM Link',
  VIEW_LB_TRIAL_MANAGE_TEAM: 'LB - Trial - View - Manage Team',
  CLICK_LB_TRIAL_MANAGE_TEAM: 'LB - Trial - Click - Manage Team',
  VIEW_LB_TRIAL_ADD_USER: 'LB - Trial - View - Add User',
  CLICK_LB_TRIAL_ADD_USER: 'LB - Trial - Click - Add User',
};

export const MX_ONBOARDING_EVENTS = {
  LB_OB_FIRST_SEARCH_PERFORMED: 'LB - OB - First Search',
  LB_OB_FIRST_SAVED_SEARCH: 'LB - OB - First Search Saved',
  LB_OB_FIRST_CONTACT_DOWNLOADED: 'LB - OB - First Contact Downloaded',
  LB_OB_FIRST_CONTACT_ADDED_TO_LIST: 'LB - OB - First Contact Added to list',
  LB_OB_CONNECTED_TO_CRM: 'LB - OB - Connected the CRM',
  LB_OB_SKIP: 'LB - OB - Skip Onboarding',
  LB_OB_GET_STARTED_CLICKED: 'LB - OB - Get Started Clicked',
  LB_OB_SKIPPED_TOUR: 'LB - OB - Skipped Tour',
  LB_OB_COMPLETED: 'LB - OB - Onboarding Completed',
  LB_OB_PROSPECTOR_DOWNLOAD_CLICKED: 'LB - OB - Prospector Download Clicked',
  LB_OB_INVITE_USER_CLICKED: 'LB - OB - Invited Users Clicked',
  LB_OB_G2_REVIEW_CLICKED: 'LB - OB - G2 Review Clicked',
  LB_OB_TALK_TO_US_CLICKED: 'LB - OB - Talk To Us Clicked',
  LB_OB_UPGRADE_NOW_CLICKED: 'LB - OB - Upgrade Now Clicked',
  LB_AP_START_FREE_TRIAL_ACTION_TRIGGER:
    'LB - AP - Start Free Trial Action - Trigger',
  LB_AP_POPUP_START_FREE_TRIAL_INFO_SCREEN:
    'LB - AP - Popup - Start Free Trial - Info Screen',
  LB_AP_POPUP_START_FREE_TRIAL_EMAIL_SCREEN:
    'LB - AP - Popup - Start Free Trial - Email Screen',
  LB_AP_POPUP_START_FREE_TRIAL_FORM_SCREEN:
    'LB - AP - Popup - Start Free Trial - Form Screen',
  LB_AP_POPUP_START_FREE_TRIAL_SUBMITTED:
    'LB - AP - Popup - Start Free Trial - Submitted',
};

export const MX_HEADER_EVENT = {
  START_FREE_TRIAL: 'Start free trial',
  SCHEDULE_DEMO: 'Schedule demo',
  START_FREE_TRIAL_RETRY: 'Start free trial - retry',
  START_FREE_TRIAL_EMAIL_SENT: 'Start free trial - Email Sent',
  START_FREE_TRIAL_SAME_DOMAIN_ERROR: 'Start free trial - same domain error',
  START_FREE_TRIAL_UNKNOWN_ERROR: 'Start free trial - unknown error',
  START_FREE_TRIAL_ACTIVATED: 'Start free trial - activated',
  CLICK_LB_SEE_PRICING: 'LB - Click - See Pricing',
  START_FREE_TRIAL_FIRST_TIME: 'Start free trial - first time',
  LB_REQUEST_QUOTE: 'LB - Request Quote',
};

export const MX_PRICING_CALCULATOR_EVENT = {
  VIEW_LB_PRICING_CALCULATOR_PAGE: 'LB - Pricing Calculator Page Viewed',
  VIEW_LB_PRICING_CALCULATOR_REVIEW_POPUP:
    'LB - Pricing Calculator - View - Review Popup',
  CLICK_LB_PRICING_CALCULATOR_TOGGLE_SUBSCRIPTION_PLAN:
    'LB - Pricing Calculator - Toggle - Subscription Plan',
  CLICK_LB_PRICING_CALCULATOR_SLIDER_CONTACTS:
    'LB - Pricing Calculator - Slider - Contacts',
  CLICK_LB_PRICING_CALCULATOR_SLIDER_LICENCES:
    'LB - Pricing Calculator - Slider - Licenses',
  CLICK_LB_PRICING_CALCULATOR_BUY_NOW:
    'LB - Pricing Calculator - Click - Buy Now',
  CLICK_LB_PRICING_CALCULATOR_SCHEDULE_CALL:
    'LB - Pricing Calculator - Click - Schedule a call',
  CLICK_LB_PRICING_CALCULATOR_PURCHASE_PLAN:
    'LB - Pricing Calculator - Click - Purchase plan',
  LB_PRICING_CALCULATOR_PAYMENT_FAILED:
    'LB - Pricing Calculator - Payment Failed',
  LB_PRICING_CALCULATOR_PAYMENT_SUCCESS:
    'LB - Pricing Calculator - Payment Success',
  LB_PRICING_CALCULATOR_FORM_VALIDATION_ERROR:
    'LB - Pricing Calculator - Form Validation Error',
  LB_PRICING_CALCULATOR_FORM_STRIPE_TOKEN_ERROR:
    'LB - Pricing Calculator - Stripe Token Error',
};

export const MX_PRICING_PAGE = {
  VIEW_LB_PRICING_PAGE: 'LB - Pricing Page Viewed',
  CLICK_LB_PRICING_PLAN_SELECTED: 'LB - Pricing - Click - Plan Selected',
  CLICK_LB_PRICING_PURCHASE_PLAN: 'LB - Pricing - Click - Purchase plan',
  LB_PRICING_PAYMENT_FAILED: 'LB - Pricing - Payment Failed',
  LB_PRICING_PAYMENT_SUCCESS: 'LB - Pricing - Payment Success',
  LB_PRICING_FORM_VALIDATION_ERROR: 'LB - Pricing - Form Validation Error',
  LB_PRICING_FORM_STRIPE_TOKEN_ERROR: 'LB - Pricing - Stripe Token Error',
  CLICK_LB_PRICING_TALK_TO_US: 'LB - Pricing - Click - Talk to us',
  CLICK_LB_PRICING_ENTERPRISE_TRIAL_TALK_TO_US:
    'LB - Pricing - Click - Enterprise - Talk to us',
};

export const MX_ADV_SEARCH_TAM = {
  LB_ADV_CONTACT_TAM_STARTED: 'LB - TAM Started',
  LB_ADV_CONTACT_TAM_INDUSTRY_FILTER: 'LB - TAM Industry Provided',
  LB_ADV_CONTACT_TAM_DEPARTMENT_FILTER: 'LB - TAM Department Provided',
  LB_ADV_CONTACT_TAM_LEVEL_FILTER: 'LB - TAM Level Provided',
  LB_ADV_CONTACT_TAM_LOCATION_FILTER: 'LB - TAM Location Provided',
  LB_ADV_CONTACT_TAM_COMPLETE: 'LB - TAM Complete',
  LB_ADV_CONTACT_TAM_ZERO_RESULT: 'LB - TAM Zero Results',
};

export const MX_PAYG_PRICING_EVENT = {
  LB_PAYG_PURCHASE_FLOW_BUY_MORE_POPUP:
    'LB - PAYG - Purchase Flow - Buy More Popup Viewed',
  LB_PAYG_BUY_CTA_CLICK: 'LB - PAYG - Buy CTA - Clicked',
  LB_PAYG_CVV_SCREEN_VIEWED: 'LB - PAYG - CVV Screen - Viewed',
  LB_PAYG_CVV_VALIDATION_CLICK: 'LB - PAYG - CVV Validation - Click ',
  LB_PAYG_PAYMENT_STATUS_SCREEN_VIEWED:
    'LB - PAYG - Payment Status Screen  - Viewed',
  LB_PAYG_BUY_NOW_CLICKED: 'LB - PAYG - Buy Now - Clicked',
  LB_PAYG_BUY_MORE_HEADER_CLICKED: 'LB - PAYG - Buy More Header CTA - click',
  LB_PAYG_BUY_MORE_ENTERPRISE_CLICKED:
    'LB - PAYG - Buy More Enterprise CTA - click',
};

export const MANAGE_TEAM_EVENTS = {
  LB_ADD_MEMBER: 'LB - TEAM - ADD',
  LB_EDIT_MEMBER: 'LB - TEAM - EDIT',
  LB_DELETE_MEMBER: 'LB - TEAM - DELETE',
};

export const MX_UPDATE_EMAIL_EVENTS = {
  LB_UPDATE_EMAIL_SHOW_POPUP_CLICK: 'LB - Update Email - Show Popup Click',
  LB_UPDATE_EMAIL_CLICKED: 'LB - Update Email - Clicked',
  LB_UPDATE_EMAIL_SUCCESS: 'LB - Update Email - Success',
  LB_UPDATE_EMAIL_FAILED: 'LB - Update Email - Failed',
};

export const MX_SET_PASSWORD_EVENTS = {
  LB_SET_PASSWORD_PAGE_VIEWED: 'LB - Set Password - Page Viewed',
  LB_SET_PASSWORD_CLICKED: 'LB - Set Password - Clicked',
  LB_SET_PASSWORD_SUCCESS: 'LB - Set Password - Success',
  LB_USE_CASE_LIST_PAGE_VIEWED: 'LB - User Case List - Page Viewed',
  LB_USE_CASE_LIST_UPDATED: 'LB - User Case List - Updated',
  LB_USE_CASE_LIST_SKIPPED: 'LB - User Case List - Skipped',
};

export const MX_PERSONALISED_ONBOARDING_EVENTS = {
  LB_GOAL_POPUP_CLICKED: 'LB - Goal Pop-up Clicked',
  LB_GOAL_EMAIL_CAMPAIGN: 'LB - Email List Goal',
  LB_GOAL_TARGET_ACCOUNTS: 'LB - Target Accounts Goal',
  LB_GOAL_AD_AUDIENCE: 'LB - Ad Audience List Goal',
  LB_GOAL_SINGLE_CONTACT: 'LB - Single Contact Goal',
  LB_GOAL_CURRENT_STEP_VALUE: {
    START_GOAL: 'Start Goal',
    DEFINE: 'Define',
    SELECT: 'Select',
    EXPORT: 'Export',
    FIND_MATCHING_CONTACTS: 'Find Matching Contacts',
    SEARCH_INITIATED: 'Search Initiated',
    NO_RESULTS: 'No Results',
    AP_LINK_CLICKED: 'AP Linked Clicked',
  },
  LB_GOAL_COMPLETE: 'LB - Goal Complete',
};

export const PRICING_FREQ_ASK_QUESTIONS = [
  {
    title: 'What are the CRMs you integrate with?',
    description:
      'We integrate with popular CRMs including Salesforce, Pipedrive, Hubspot, Marketo, Outreach, Zoho, Salesgear, etc.',
  },
  {
    title: 'Is my purchase information safe?',
    description:
      'We use Stripe for payment. All payment related information are secured and anonymized for your safety.',
  },
  {
    title: 'How can I add team members to the platform?',
    description:
      'Go to the user icon on the bottom left. Select the manage team option to invite your teammates to your account. Please note that seats are charged as per your plan.',
  },
  {
    title:
      'What can I do if the email ID I have downloaded is incorrect/bouncing?',
    description:
      'Please write to <a href="mailto:support@adapt.io">support@adapt.io</a> with the list of bounced email IDs. Our team will validate the data you shared and add credits to your account accordingly.',
  },
  {
    // eslint-disable-next-line quotes
    title: "What's your cancellation/refund policy?",
    description:
      'Please write an email to <a href="mailto:support@adapt.io">support@adapt.io</a> and our support team will help you with the account cancellation or refund.',
  },
];

export const PAYG_PRICING_FREQ_ASK_QUESTIONS = [
  {
    title: "What makes Adapt's Plans different?",
    description:
      'Data is currently sold as a subscription, this pushes you to pay a fee to keep the subscription going monthly. We realize that data pulls scale up and down based on the campaigns undertook by your team. <br /><br /> Hence, we have a single access fee for a whole year that gives you 2000+ credits. You can purchase more credits as you go, and when you need it. No more complicated business.',
  },
  {
    title: 'What are credits?',
    description:
      `1 Credit = 1 contact information revealed.<br />With one credit you get access to complete information like email address, phone number, role, company and more. <br /><br />  You can use the credits in, <ol><li>Adapt's Web Platform to search across ${CONTACT_COUNT_IN_MILLIONS} contact database.</li><li>Chrome plugin to find data from LinkedIn or Company websites.</li></ol>`,
  },
  {
    title: 'How does the billing work?',
    description:
      'For our growth plan, your credit card is charged for $299 on purchase. Users will receive all credits at the moment of purchase. <br /><br /> Once you exhaust the credits that come with our growth plan, you can then purchase credits as you need.',
  },
  {
    title: 'Will my credits expire?',
    description: 'Your credits are valid till your subscription lasts.',
  },
  {
    title: 'How can I get credit refund for hard bounces?',
    description:
      'Once you send us the list of contacts that have hard bounced, Your credits will be refunded after we verify from our end as well.',
  },
  {
    title: 'Does my plan renew automatically?',
    description:
      'You have complete control over the renewal of your plan and you can decide if you want to auto renew or not.',
  },
  {
    title: 'What are the CRMs you integrate with?',
    description:
      'We integrate with popular CRMs including Salesforce, Pipedrive, Hubspot, Marketo, Outreach, Zoho, Salesgear, etc.',
  },
  {
    title: 'Is my purchase information safe?',
    description:
      'We use Stripe for payment. All payment related information are secured and anonymized for your safety.',
  },
  {
    title:
      'What can I do if the email ID I have downloaded is incorrect/bouncing?',
    description:
      'Please write to <a href="mailto:support@adapt.io">support@adapt.io</a> with the list of bounced email IDs. Our team will validate the data you shared and refund credits to your account accordingly.',
  },
  // {
  //   title: 'Can I see a demo?',
  //   description:
  //     'Yes! You can drop us a request <a href="https://www.adapt.io/request-demo/" target="_blank">here</a>. If you have any specific doubts, please write to <a href="mailto:sales@adapt.io">sales@adapt.io</a>',
  // },
];

export const MEMBER_ONBOARDING_INFO = {
  FREE_TRIAL_ONE_TIME_POPUP: 'free_trial_one_time_popup',
  PAID_USER_TECHNOLOGY_FILTER_ONE_TIME_POPUP:
    'paid_user_technology_filter_one_time_popup',
};

export const HUBSPOT_EVENTS = {
  SELF_SERVE_BUY_NOW_CLICK: 'self_serve_buy_now_click',
  SELF_SERVE_TALK_TO_US_CLICK: 'self_serve_talk_to_us_click',
  SELF_SERVE_PAGE_VIEWED: 'self_serve_page_viewed',
};

export const CONTACT_PURCHASE_TYPES = {
  DIRECT_PURCHASE: 'DIRECT_PURCHASE',
  ASYNC_PURCHASE: 'ASYNC_PURCHASE',
  DIRECT_PURCHASE_CRITERIA: 'DIRECT_PURCHASE_CRITERIA',
  ASYNC_PURCHASE_CRITERIA: 'ASYNC_PURCHASE_CRITERIA',
  LIMIT_CONTACT_PER_COMPANY: 'LIMIT_CONTACT_PER_COMPANY',
  ASYNC_PURCHASE_IDS: 'ASYNC_PURCHASE_IDS',
};

export const CONTACT_EXPORT_TYPES = {
  DIRECT_EXPORT: 'DIRECT_EXPORT',
  ASYNC_EXPORT: 'ASYNC_EXPORT',
  DIRECT_EXPORT_CRITERIA: 'DIRECT_EXPORT_CRITERIA',
  ASYNC_EXPORT_CRITERIA: 'ASYNC_EXPORT_CRITERIA',
};

export const ASYNC_TRANSACTION_MIN_COUNT = 6;
export const ASYNC_PURCHASE_MIN_COUNT = ASYNC_TRANSACTION_MIN_COUNT;
export const ASYNC_EXPORT_MIN_COUNT = ASYNC_TRANSACTION_MIN_COUNT;

export const HP_DOMAIN_URL = 'hpe.com';

export const REFINER_EVENTS_AND_PROPERTIES = {
  LB_REF_PROPERTY_SEARCH_PERFORMED: 'searchPerformed',
  LB_REF_PROPERTY_CREDITS_REMAINING: 'creditsRemaining',
  LB_REF_PROPERTY_CONTACT_OR_COMPANY_NAME_FILTER_APPLIED:
    'contactOrCompanyNameFilterApplied',
  LB_REF_PROPERTY_SEARCH_RESULT_COUNT: 'searchResultCount',
  LB_REF_PROPERTY_NO_OF_DAYS_LEFT_IN_TRIAL: 'noOfDaysLeftIntrial',
  LB_REF_PROPERTY_PRICING_VISITED: 'pricingPageVisited',
  LB_REF_PROPERTY_USER_PAGE_SOURCE: 'userPageSource',
};

export const UPGRADE_TRIGGERS = {
  BULK_EXPORT_IN_ADV: 'BULK_EXPORT_IN_ADV',
  SINGLE_CSV_EXPORT: 'SINGLE_CSV_EXPORT',
  COMMON_PLATFORM_FEATURE: 'COMMON_PLATFORM_FEATURE',
  PAGINATION: 'PAGINATION',
  VIEW_CONTACT_NO_CREDIT: 'VIEW_CONTACT_NO_CREDIT',
  EXPORT_SELECTED_TO_CSV_IN_MY_LEADS: 'EXPORT_SELECTED_TO_CSV_IN_MY_LEADS',
  EXPORT_SELECTED_TO_CRM_IN_MY_LEADS: 'EXPORT_SELECTED_TO_CRM_IN_MY_LEADS',
  EXPORT_LIST_IN_MY_LEADS: 'EXPORT_LIST_IN_MY_LEADS',
  CRM_INTEGRATIONS: 'CRM_INTEGRATIONS',
  STARTER_CRM_EXPORT: 'STARTER_CRM_EXPORT',
  PURCHASE_PHONE: 'PURCHASE_PHONE',
};

export const INSIDE_STORY_ENKI_EVENTS = [
  {
    name: 'Executive and Market Thought Leader Insights',
    selected: false,
  },
  {
    name: 'Partnerships',
    selected: false,
  },
  {
    name: 'Challenges and Pain Points',
    selected: false,
  },
  {
    name: 'Investments and Acquisitions',
    selected: false,
  },
  {
    name: 'Strategic Initiatives',
    selected: false,
  },
  {
    name: 'Recent Wins',
    selected: false,
  },
  {
    name: 'Generic',
    selected: false,
  },
  {
    name: 'Executive Moves',
    selected: false,
  },
];

export const INSIDE_STORY_MAPPER = [
  {
    name: 'Accidents, Disasters & Outages',
    codes: ['KW_616', 'KW_531', 'KW_601'],
    selected: false,
  },
  {
    name: 'Awards',
    codes: ['KW_532'],
    selected: false,
  },
  {
    name: 'Business Disruption',
    codes: ['KW_146', 'KW_677', 'KW_737'],
    selected: false,
  },
  {
    name: 'Business Expansion',
    codes: ['KW_640', 'KW_527', 'KW_556', 'KW_533', 'KW_713'],
    selected: false,
  },
  {
    name: 'Finance',
    codes: [
      'KW_647',
      'KW_675',
      'KW_653',
      'KW_519',
      'KW_664',
      'KW_609',
      'KW_638',
      'KW_568',
      'KW_510',
      'KW_685',
      'KW_708',
      'KW_597',
      'KW_14',
      'KW_611',
      'KW_646',
      'KW_608',
      'KW_600',
    ],
    selected: false,
  },
  {
    name: 'Funding',
    codes: ['KW_514'],
    selected: false,
  },
  {
    name: 'Hiring',
    codes: ['KW_529'],
    selected: false,
  },
  {
    name: 'IPO',
    codes: ['KW_516'],
    selected: false,
  },
  {
    name: 'Leadership Change',
    codes: ['KW_591', 'KW_502', 'KW_741'],
    selected: false,
  },
  {
    name: 'Legal',
    codes: ['KW_711', 'KW_526'],
    selected: false,
  },
  {
    name: 'Merger & Acquisitions',
    codes: ['KW_535', 'KW_518', 'KW_666'],
    selected: false,
  },
  {
    name: 'Partnership',
    codes: ['KW_512', 'KW_661', 'KW_513', 'KW_644'],
    selected: false,
  },
  {
    name: 'Product Launch',
    codes: ['KW_521', 'KW_566'],
    selected: false,
  },
  {
    name: 'R&D',
    codes: ['KW_537', 'KW_588', 'KW_589'],
    selected: false,
  },
  {
    name: 'Rebranding',
    codes: ['KW_709'],
    selected: false,
  },
  {
    name: 'Regulatory',
    codes: [
      'KW_584',
      'KW_517',
      'KW_697',
      'KW_522',
      'KW_613',
      'KW_593',
      'KW_523',
      'KW_699',
      'KW_655',
      'KW_656',
    ],
    selected: false,
  },
  {
    name: 'Restructuring',
    codes: [
      'KW_641',
      'KW_586',
      'KW_687',
      'KW_528',
      'KW_534',
      'KW_536',
      'KW_520',
    ],
    selected: false,
  },
  {
    name: 'Rumors & Scandals',
    codes: ['KW_665', 'KW_654'],
    selected: false,
  },
  {
    name: 'Security',
    codes: ['KW_530'],
    selected: false,
  },
  {
    name: 'Sourcing & procurement',
    codes: ['KW_676', 'KW_571', 'KW_703'],
    selected: false,
  },
  {
    name: 'Other',
    codes: [
      'KW_143',
      'KW_636',
      'KW_635',
      'KW_645',
      'KW_760',
      'KW_660',
      'KW_659',
      'KW_658',
      'KW_688',
      'KW_610',
      'KW_538',
      'KW_614',
      'KW_612',
      'KW_749',
      'KW_652',
      'KW_215',
      'KW_651',
      'KW_615',
      'KW_592',
      'KW_649',
      'KW_583',
      'KW_802',
      'KW_680',
      'KW_738',
      'KW_634',
      'KW_585',
      'KW_698',
      'KW_686',
      'KW_736',
      'KW_648',
      'KW_803',
      'KW_801',
      'KW_707',
      'KW_696',
      'KW_689',
      'KW_650',
      'KW_734',
      'KW_637',
      'KW_706',
      'KW_642',
      'KW_700',
      'KW_673',
      'KW_524',
      'KW_714',
      'KW_701',
      'KW_674',
      'KW_678',
      'KW_743',
      'KW_748',
      'KW_740',
      'KW_607',
      'KW_702',
    ],
    selected: false,
  },
];

export const MX_PROFILE_PROPERTIES = {
  TAM_LOCATION: 'TAM Location',
  TAM_INDUSTRY: 'TAM Industry',
  TAM_DEPARTMENT: 'TAM Department',
  TAM_ROLE: 'TAM Role',
  TAM_PRICING_VIEWED: 'Trial Pricing Viewed',
  LAST_USER_ACTIVITY: 'Last Activity',
  PLAN_TYPE: 'Plan Type',
  CREDITS_ALLOCATED: 'Credits Allocated',
  CREDITS_REMAINING: 'Credits Remaining',
  LAST_SEARCH_PERFORMED: 'Last Search Performed',
  TOTAL_SEARCHES_PERFORMED: 'Total Search Performed',
  TOTAL_SEARCH_RESULT_COUNT: 'Total Contact Search Result',
  TOTAL_SEARCH_COMPANY_RESULT_COUNT: 'Total Company Search Result',
  TOTAL_CONTACTS_PURCHASED: 'Total Contacts Purchased',
  ENTERPRISE_PLAN_REQUEST: 'Enterpise Plan Request',
  SEAT_ELIGIBLE: 'Seat Eligible',
  SEAT_USED: 'Seat Used',
  ENTERPRISE_TRIAL: 'Enterprise Trial',
  PLAN_PRICE: 'Plan Price',
  AP_TRIAL_REQUEST_USER_TYPE: 'AP Trial Request User Type',
};

export const enrichmentPreferenceOptions = [
  { label: 'Overwrite', value: 'OVERWRITE' },
  { label: 'Skip', value: 'SKIP' },
  { label: 'Enrich if missing', value: 'ENRICH_IF_MISSING' },
];

export const G2_EVENTS = {
  G2_POPUP_SHOWN: 'LB - G2review - Shown',
  G2_LINK_CLICKED: 'LB - G2review - Clicked',
};

export const SEOCookieQueryMapping = {
  seoSearch: 'seo_search',
  seoPageData: 'seo_page_data',
  seoSearchJSON: 'seo_searchJson',
  seoContactURL: 'seo_contact_url',
  landingURL: 'trial_landingURL',
  contactId: 'seo_contact_id',
};

export const CRM_FIELD_TYPES = {
  ENUM: 'ENUM',
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
};

export const DO_NOT_MAP_FIELD = {
  label: 'Don’t Map this field',
  value: 'DO_NOT_MAP',
};

export const USER_INTEREST_LIST = [
  {
    key: 'AD_AUDIENCE_LIST',
    content: 'I am here to build an Ad audience list',
    selected: false,
    value: 'Ad Audience List',
  },
  {
    key: 'EMAIL_CAMPAIGN_LIST',
    content: 'I am here to build an Email Campaign List',
    selectedContent: 'Which tool are you using for Email Campaigns?',
    selected: false,
    value: 'Email Campaign List',
    toolsList: [
      'MailChimp',
      'SendinBlue',
      'Hubspot',
      'Campaign Monitor',
      'Constant Contact',
      'Drip',
      'Moosend',
      'Other',
    ],
  },
  {
    key: 'TARGETED_ACCOUNTS',
    content: 'I am here to get contacts of targeted accounts',
    selected: false,
    value: 'Targeted Accounts',
  },
  {
    key: 'SINGLE_CONTACT_ONLY',
    content: 'I am here for single contact data - nothing more',
    selected: false,
    value: 'Single Contact Only',
  },
  {
    key: 'ENRICH_CRM_DATA',
    content: 'I am here to enrich my CRM data ',
    selectedContent: 'Which CRM do you use?',
    selected: false,
    value: 'Enrich CRM Data',
    toolsList: [
      'Salesforce',
      'HubSpot',
      'Zoho CRM',
      'Pipedrive',
      'Freshsales',
      'Dynamics 365',
      'Zendesk',
      'Other',
    ],
  },
];

export const PERSONALIED_ONBOARDING_FLOWS = {
  INITIAL_GUIDE_FLOW: 'INITIAL_GUIDE_FLOW',
  STARTER_FLOW: 'STARTER_FLOW',
  EMAIL_CAMPAIGN_LIST: 'EMAIL_CAMPAIGN_LIST',
  AD_AUDIENCE_LIST: 'AD_AUDIENCE_LIST',
  TARGETED_ACCOUNTS: 'TARGETED_ACCOUNTS',
  SINGLE_CONTACT_ONLY: 'SINGLE_CONTACT_ONLY',
};

export const FREE_TRIAL_POPUP_TRIGGERS = {
  VIEW_LIST: 'view-list',
  EXPORT_CONTACT: 'export-contact',
  SINGLE_VIEW_CONTACTS: 'single-view-contacts',
  WEBSITE_VIEW_CONTACTS: 'website-view-contacts',
  DIRECT_ACCESS: 'direct-access',
  HEADER_BUTTON_ACTION: 'header-button-action',
};

export const timezones = [
  '(GMT-12:00) Eniwetok, Kwajalein',
  '(GMT-11:00) Midway Island, Samoa',
  '(GMT-10:00) Hawaii',
  '(GMT-09:00) Alaska',
  '(GMT-08:00) Pacific Time US/Canada',
  '(GMT-07:00) Mountain Time US/Canada',
  '(GMT-06:00) Central Time US/Canada, Mexico City',
  '(GMT-05:00) Eastern Time US/Canada, Bogota, Lima',
  '(GMT-04:00) Atlantic Time Canada, Caracas, La Paz',
  '(GMT-03:30) Newfoundland',
  '(GMT-03:00) Brazil, Buenos Aires, Georgetown',
  '(GMT-02:30) America/St_Johns',
  '(GMT-02:00) Mid-Atlantic',
  '(GMT-01:00) Azores, Cape Verde Islands',
  '(GMT+00:00) Western Europe Time, London, Lisbon, Casablanca',
  '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
  '(GMT+02:00) Kaliningrad, South Africa',
  '(GMT+03:00) Baghdad, Riyadh, Moscow, St. Petersburg',
  '(GMT+03:30) Tehran',
  '(GMT+04:00) Abu Dhabi, Muscat, Baku, Tbilisi',
  '(GMT+04:30) Kabul',
  '(GMT+05:00) Ekaterinburg, Islamabad, Karachi, Tashkent',
  '(GMT+05:30) Chennai, Mumbai, New Delhi, Kolkata',
  '(GMT+05:45) Kathmandu',
  '(GMT+06:00) Almaty, Dhaka, Colombo',
  '(GMT+06:30) Asia/Rangoon',
  '(GMT+07:00) Bangkok, Hanoi, Jakarta',
  '(GMT+08:00) Beijing, Perth, Singapore, Hong Kong',
  '(GMT+08:30) Asia/Pyongyang',
  '(GMT+08:45) Australia/Eucla',
  '(GMT+09:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
  '(GMT+09:30) Adelaide, Darwin',
  '(GMT+10:00) Eastern Australia, Guam, Vladivostok',
  '(GMT+10:30) Australia/LHI',
  '(GMT+11:00) Magadan, Solomon Islands, New Caledonia',
  '(GMT+12:00) Auckland, Wellington, Fiji, Kamchatka',
  '(GMT+13:00) Antarctica/McMurdo',
  '(GMT+13:45) NZ-CHAT',
  '(GMT+14:00) Etc/GMT-14',
];

export const enrichmentStatusText = {
  COMPLETED: 'Enrichment Complete',
};

export const ENRICHMENT_LOG_MAX_LIMIT = 50000;

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const timeZonesList = [
  {
    label: '(GMT-08:00) Pacific Time US/Canada - PST',
    value: 'PST',
  },
  {
    label: '(GMT-05:00) Eastern Time US/Canada, Bogota, Lima - EST',
    value: 'EST',
  },
  {
    label: '(GMT+00:00) Western Europe Time, London, Lisbon, Casablanca - GMT',
    value: 'GMT',
  },
  {
    label: '(GMT+05:30) Chennai, Mumbai, New Delhi, Kolkata - IST',
    value: 'IST',
  },
  {
    label: '(GMT-12:00) Eniwetok, Kwajalein',
    value: 'Kwajalein',
  },
  {
    label: '(GMT-11:00) Midway Island, Samoa - MIT',
    value: 'MIT',
  },
  {
    label: '(GMT-10:00) Hawaii - HST',
    value: 'HST',
  },
  {
    label: '(GMT-09:00) Alaska',
    value: 'US/Alaska',
  },
  {
    label: '(GMT-07:00) Mountain Time US/Canada - MST',
    value: 'MST',
  },
  {
    label: '(GMT-06:00) Central Time US/Canada, Mexico City - CST',
    value: 'CST',
  },
  {
    label:
      '(GMT-04:00) Atlantic Time Canada, Caracas, La Paz, Puerto Rico - PRT',
    value: 'PRT',
  },
  {
    label: '(GMT-03:30) Newfoundland - CNT',
    value: 'CNT',
  },
  {
    label: '(GMT-03:00) Brazil, Buenos Aires, Georgetown - BET',
    value: 'BET',
  },
  {
    label: '(GMT-02:30) America/St_Johns',
    value: 'America/St_Johns',
  },
  {
    label: '(GMT-02:00) Atlantic, South Georgia',
    value: 'Atlantic/South_Georgia',
  },
  {
    label: '(GMT-01:00) Azores, Cape Verde Islands',
    value: 'Atlantic/Cape_Verde',
  },
  {
    label: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris - ECT',
    value: 'ECT',
  },
  {
    label: '(GMT+02:00) Kaliningrad, South Africa - CAT',
    value: 'CAT',
  },
  {
    label: '(GMT+03:00) East Africa Time - EAT',
    value: 'EAT',
  },
  {
    label: '(GMT+03:30) Tehran',
    value: 'Asia/Tehran',
  },
  {
    label: '(GMT+04:00) Armenia, Abu Dhabi, Muscat, Baku, Tbilisi - NET',
    value: 'NET',
  },
  {
    label: '(GMT+04:30) Kabul',
    value: 'Asia/Kabul',
  },
  {
    label: '(GMT+05:00) Ekaterinburg, Islamabad, Karachi, Tashkent - PLT',
    value: 'PLT',
  },
  {
    label: '(GMT+05:45) Kathmandu',
    value: 'Asia/Kathmandu',
  },
  {
    label: '(GMT+06:00) Almaty, Dhaka, Colombo - BST',
    value: 'BST',
  },
  {
    label: '(GMT+06:30) Asia/Rangoon',
    value: 'Asia/Rangoon',
  },
  {
    label: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
    value: 'Asia/Bangkok',
  },
  {
    label: '(GMT+08:00) Beijing, Perth, Singapore, Hong Kong - CTT',
    value: 'CTT',
  },
  {
    label: '(GMT+08:30) Asia/Pyongyang',
    value: 'Asia/Pyongyang',
  },
  {
    label: '(GMT+08:45) Australia/Eucla',
    value: 'Australia/Eucla',
  },
  {
    label: '(GMT+09:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk - JST',
    value: 'JST',
  },
  {
    label: '(GMT+09:30) Adelaide, Darwin - ACT',
    value: 'ACT',
  },
  {
    label: '(GMT+10:00) Eastern Australia, Guam, Vladivostok - AET',
    value: 'AET',
  },
  {
    label: '(GMT+10:30) Australia/LHI',
    value: 'Australia/LHI',
  },
  {
    label: '(GMT+11:00) Magadan, Solomon Islands, New Caledonia - SST',
    value: 'SST',
  },
  {
    label: '(GMT+12:00) Auckland, Wellington, Fiji, Kamchatka - NST',
    value: 'NST',
  },
  {
    label: '(GMT+13:00) Antarctica/McMurdo',
    value: 'Antarctica/McMurdo',
  },
  {
    label: '(GMT+13:45) NZ-CHAT',
    value: 'NZ-CHAT',
  },
  {
    label: '(GMT+14:00) Etc/GMT-14',
    value: 'Etc/GMT-14',
  },
];

export const weekDays = [
  { label: 'Monday', value: 'Monday' },
  { label: 'Tuesday', value: 'Tuesday' },
  { label: 'Wednesday', value: 'Wednesday' },
  { label: 'Thursday', value: 'Thursday' },
  { label: 'Friday', value: 'Friday' },
  { label: 'Saturday', value: 'Saturday' },
  { label: 'Sunday', value: 'Sunday' },
];

export const time = [
  { label: '12 AM', value: '00:00 AM' },
  { label: '1 AM', value: '01:00 AM' },
  { label: '2 AM', value: '02:00 AM' },
  { label: '3 AM', value: '03:00 AM' },
  { label: '4 AM', value: '04:00 AM' },
  { label: '5 AM', value: '05:00 AM' },
  { label: '6 AM', value: '06:00 AM' },
  { label: '7 AM', value: '07:00 AM' },
  { label: '8 AM', value: '08:00 AM' },
  { label: '9 AM', value: '09:00 AM' },
  { label: '10 AM', value: '10:00 AM' },
  { label: '11 AM', value: '11:00 AM' },
  { label: '12 PM', value: '12:00 PM' },
  { label: '1 PM', value: '01:00 PM' },
  { label: '2 PM', value: '02:00 PM' },
  { label: '3 PM', value: '03:00 PM' },
  { label: '4 PM', value: '04:00 PM' },
  { label: '5 PM', value: '05:00 PM' },
  { label: '6 PM', value: '06:00 PM' },
  { label: '7 PM', value: '07:00 PM' },
  { label: '8 PM', value: '08:00 PM' },
  { label: '9 PM', value: '09:00 PM' },
  { label: '10 PM', value: '10:00 PM' },
  { label: '11 PM', value: '11:00 PM' },
];

// include company domain size limit
// member id to max size
export const customDomainSizeIncludeCompany = {
  '6282ba31e9ec741427cce036': 1000, // scott@cambiumadvisors.com
  '618c342be9ec747e3b4868b3': 5000, // lucyd@foureyes.io
  '620e47a6e9ec74783767ba0c': 5002, // gokul@adapt.io
  '61cd560bea6f4320bcfa13f5': 5002, // gokul@adapt.io QE
};

export const customDomainSizeExcludeCompany = {
  '620e47a6e9ec74783767ba0c': 1000, // gokul@adapt.io
};

export const defaultNameDomainsMaxSize = 500;
// include company domain size limit

export const EMAIL_TYPES = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
};

export const ENRICHMENT_IGNORED_CRMS = ['SALESFORCE'];

export const FIELD_MAPPING_VALUE_EXAMPLES = {
  firstName: 'Jane',
  lastName: 'Edwards',
  companyName: 'Adapt.io',
  title: 'Chief Executive Officer',
  companyWebsite: 'www.adapt.io',
  phoneDirect: '+91 98181 02843',
  phoneMobile: '+91 98181 02843',
  phoneCompany: '+91 98181 02843',
  country: 'United States',
  state: 'California',
  city: 'New York',
  level: 'C-Level',
  department: 'Sales',
  secondaryDepartment: 'Customer Success',
  companyCountry: 'United States',
  companyState: 'California',
  companyCity: 'New York',
  companyPincode: '90001',
  companyStreet: '17 State Street',
  companyHeadCount: '500+',
  companyRevenue: '$0 - 1M',
  linkedInURL: 'https://www.linkedin.com/company/adapt-io/',
  industry: 'IT Services',
  sector: 'Informaion Technology and Services',
  phoneOther1: '+91 98181 02843',
  listName: 'C-Level contacts',
};

export const NEW_INTEGRATION_NOT_AVAILABLE_CRMS = [
  'PIPEDRIVE',
  'ZOHO',
  'OUTREACH',
  'MARKETO',
  'MSDYNAMICS',
];

export const MX_EMAIL_DIGEST_EVENTS = {
  USAGE_ANALYTICS_VIEWED: 'LB - Usage Analytics Viewed',
  ONE_TIME_EMAIL_CREATE: 'LB-UA-Email-Create',
  EMAIL_DIGEST_CREATE: 'LB-UA-Digest-Create',
  EMAIL_DIGEST_UPDATE: 'LB-UA-Digest-Update',
  EMAIL_DIGEST_DELETE: 'LB-UA-Digest-Delete',
};

export const EMPTY_FUNCTION = () => {};

export const MX_SAVED_SEARCH_BANNER = {
  SHOWN: 'LB - Save Search Banner Shown',
  SAVE_SEARCH_CLICKED: 'LB - Save Search Banner (CTA) Clicked',
  CLOSED: 'LB - Save Search Banner Close Clicked',
};

export const MX_CONTACT_UPDATE_EVENTS = {
  JOB_CHANGE_VIEW_CONTACT: 'LB - Job Changes View Contact Clicked',
  JOB_CHANGES_BULK_PURCHASE_CLICKED: 'LB - Job Changes Bulk Purchase Clicked',
  CONTACT_NAME_CLICK: 'LB - Job Changes Contact Name Clicked',
  TAB_FILTER_CHANGED: 'ML - List Day Filter Changed',
};

export const MX_ENRICHMENT_EVENTS = {
  ENRICHMENT_LANDING_VIEWED: 'LB - Enrichment Landing Viewed',
  ENRICHMENT_CARD_CLICKED: 'LB - Enrichment Landing Card Clicked',
  FILE_ENRICHMENT_VIEWED: 'LB - File Enrichment Page Viewed',
  FILE_ENRICHMENT_FILE_UPLOAD: 'LB - File Enrichment Choose File Clicked',
  VIEW_REPORT_BUTTON_CLICKED: 'LB - File Enrichment View Report Button Clicked',
  DOWNLOAD_BUTTON_CLICKED: 'LB - File Enrichment Download Button Clicked',
  FILE_ENRICHMENT_CREATED: 'LB - File Enrichment Created',
  CSV_FIELD_MAPPING_SHOWN: 'LB - File Enrichment Field Mapping Shown',
  ERROR_POPUP_SHOWN: 'LB - File Enrichment Error Popup Shown',
  CRM_ENRICHMENT_LOG_PAGE_VIEWED: 'LB - CRM Enrichment Log Page Shown',
  VIEW_UPDATES_BTN_CLICKED: 'LB - CRM Enrichment Log View Updates Viewed',
  DOWNLOAD_LOG_CLICKED: 'LB - CRM Enrichment Download Log Clicked',
  DATE_FILTER_APPLIED: 'LB - CRM Enrichment Date Filter Applied',
  AUTO_ENRICHMENT_TOGGLED: 'LB - CRM Enrichment Auto Enrichment Toggled',
  AUTO_ENRICHMENT_NOTIFICATION_TOGGLED:
    'LB - CRM Enrichment Auto Enrichment Notification Toggled',
  CRM_ENRICHMENT_CONNECT_STEP_SHOWN: 'LB - CRM Enrichment Connect Step Shown',
  CRM_ENRICHMENT_MAPPING_STEP_SHOWN:
    'LB - CRM Enrichment Field Mapping Step Shown',
  CRM_ENRICHMENT_SETTINGS_STEP_SHOWN: 'LB - CRM Enrichment Settings Step Shown',
  CRM_ENRICHMENT_CONNECT_CLICKED: 'LB - CRM Enrichment Connect Button Clicked',
};

export const MY_LEADS_TABS = [
  'All contacts',
  'Job Changes',
  'Role Changes',
  'Other Updates',
];

export const defaultDateValue = {
  startDate: null,
  // https://github.com/hypeserver/react-date-range/issues/330#issuecomment-802601417
  endDate: new Date(''),
  key: 'selection',
};

export const MOBILE_NUMBER_EVENTS = {
  SHOW_INTEREST: 'LB - Mobile Number Interested',
  PURCHASE_MOBILE: 'LB - Mobile Number Purchase',
  MOBILE_NUMBER_UPGRADE_POPUP_SHOWN: 'LB - Mobile Number Upgrade Popup Shown',
  PHONE_CREDITS_EXPIRED_POPUP_SHOWN:
    'LB - Mobile Number Credits Expired Popup Shown',
  PHONE_CREDITS_EXPIRED_BUY_MORE_CLICKED:
    'LB - Mobile Number Credits Expired Buy More Clicked',
};
